import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { queryClient } from '@/api/queryClient.ts'
import { useAudioStore } from '@/store/AudioStore.ts'

interface ILoginStore {
    accessToken: string
    login: (id: string, accessToken: string) => Promise<void>
    logout: () => Promise<void>
    isAutoLogin?: boolean
    isSaveID?: boolean
    savedID?: string
    setAutoLogin: (checked: boolean) => void
    setSaveID: (checked: boolean) => void
    saveID: (id: string) => void
}
// Refresh Token은 서버의 HttpOnly Cookie로만 관리됨 (프론트엔드 접근 불가)
export const useLoginStore = create<ILoginStore>()(
    persist(
        (set, get) => ({
            isAutoLogin: false,
            isSaveID: false,
            accessToken: '', // 초기에는 빈 값 (새로고침 시 메모리 초기화)
            login: async (id = '', accessToken = '') => {
                set(_ => ({ accessToken: accessToken }))

                if (get().isSaveID && id) {
                    set(_ => ({ savedID: id }))
                } else if (!get().isSaveID) {
                    set(_ => ({ savedID: '' }))
                }
            },
            logout: async () => {
                try {
                    const { apiLogout } = await import('@/api/auth/logout.ts')
                    await apiLogout()
                } catch (error) {
                    // 로그아웃 실패해도 클라이언트는 정리
                }

                set(_ => ({ accessToken: '' }))
                // Refresh Token 쿠키는 서버의 Logout API가 Max-Age=0으로 만료시킴
                useAudioStore.getState().stop()

                // 전역 queryClient의 모든 캐시 삭제
                queryClient.clear()
            },
            setAutoLogin: (checked = false) => {
                set(_ => ({ isAutoLogin: checked }))
            },
            setSaveID: (checked = false) => {
                set(_ => ({ isSaveID: checked }))
                if (!checked) {
                    set(_ => ({ savedID: '' }))
                }
            },
            saveID: (id = '') => {
                set(_ => ({ savedID: id }))
            }
        }),
        {
            name: 'login-store',
            // accessToken은 메모리에만 유지하고 localStorage에는 절대 저장하지 않음 (XSS 방지)
            partialize: (state) => ({
                isAutoLogin: state.isAutoLogin,
                isSaveID: state.isSaveID,
                savedID: state.savedID
            })
        }
    )
)